import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import './style.css';

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/home',
    },
    {
        id: 3,
        title: 'About',
        link: '/about',
    },
    {
        id: 4,
        title: 'Channel Doctor',
        link: '/channel-doctor',
    },
    {
        id: 5,
        title: 'Services',
        link: '/services',
    },
    {
        id: 6,
        title: 'Contact',
        link: '/contact',
    }
    // {
    //     id: 3,
    //     title: 'Pages',
    //     link: '/',
    //     submenu: [
    //         {
    //             id: 31,
    //             title: 'Doctor',
    //             link: '/team'
    //         },
    //         {
    //             id: 32,
    //             title: 'Doctor single',
    //             link: '/team-single/Marlene-Henry'
    //         },
    //         {
    //             id: 33,
    //             title: 'Shop',
    //             link: '/shop'
    //         },
    //         {
    //             id: 34,
    //             title: 'Shop Single',
    //             link: '/shop-single/prayer-mat'
    //         },
    //         {
    //             id: 35,
    //             title: 'Cart',
    //             link: '/cart'
    //         },
    //         {
    //             id: 36,
    //             title: 'Checkout',
    //             link: '/checkout'
    //         },
    //         {
    //             id: 37,
    //             title: '404 Error',
    //             link: '/404'
    //         },
    //         {
    //             id: 38,
    //             title: 'Faq',
    //             link: '/faq'
    //         },
    //     ]
    // },
    // {
    //     id: 7,
    //     title: 'Service',
    //     link: '#',
    //     submenu: [
    //         {
    //             id: 71,
    //             title: 'Services',
    //             link: '/services',
    //         },
           
    //         {
    //             id: 74,
    //             title: 'Service Single',
    //             link: '/service-single/Dental-Care',
    //         },


    //     ]
    // },
    // {
    //     id: 44,
    //     title: 'Portfolio',
    //     link: '/',
    //     submenu: [
    //         {
    //             id: 41,
    //             title: 'Portfolio',
    //             link: '/project',
    //         },
    //         {
    //             id: 42,
    //             title: 'Portfolio Single',
    //             link: '/project-single/Heart-Institure'
    //         },
    //     ]
    // },
    // {
    //     id: 5,
    //     title: 'Blog',
    //     link: '/blog',
    //     submenu: [
    //         {
    //             id: 51,
    //             title: 'Blog',
    //             link: '/blog'
    //         },
    //         {
    //             id: 52,
    //             title: 'Blog Left sidebar',
    //             link: '/blog-left-sidebar'
    //         },
    //         {
    //             id: 53,
    //             title: 'Blog full width',
    //             link: '/blog-fullwidth'
    //         },
    //         {
    //             id: 54,
    //             title: 'Blog single',
    //             link: '/blog-single/Why-Industry-Are-A-Juicy-Target-For'
    //         },
    //         {
    //             id: 55,
    //             title: 'Blog single Left sidebar',
    //             link: '/blog-single-left-sidebar/Why-Industry-Are-A-Juicy-Target-For'
    //         },
    //         {
    //             id: 56,
    //             title: 'Blog single Left sidebar',
    //             link: '/blog-single-fullwidth/Why-Industry-Are-A-Juicy-Target-For'
    //         },
    //     ]
    // },
    // {
    //     id: 88,
    //     title: 'Contact',
    //     link: '/contact',
    // }


]


const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                                {item.submenu ?
                                    <Fragment>
                                        <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                            <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                        </p>
                                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                            <List className="subMenu">
                                                <Fragment>
                                                    {item.submenu.map((submenu, i) => {
                                                        return (
                                                            <ListItem key={i}>
                                                                <NavLink onClick={ClickHandler} className="active"
                                                                    to={submenu.link}>{submenu.title}</NavLink>
                                                            </ListItem>
                                                        )
                                                    })}
                                                </Fragment>
                                            </List>
                                        </Collapse>
                                    </Fragment>
                                    : <NavLink className="active"
                                        to={item.link}>{item.title}</NavLink>
                                }
                            </ListItem>
                        )
                    })}
                </ul>

            </div>

            <div className="showmenu mobail-menu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;